export const LOGO_SUCCESS = "LOGO_SUCCESS";
export const LOGO_FAIL = "LOGO_FAIL";
